import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "NavClass"
};
const _hoisted_2 = {
  class: "textClass"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
    class: "iconClass",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.GoBack && $options.GoBack(...args))
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left"
  })], 512), [[_vShow, $props.isReturn]]), _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1)]);
}